import { Group, Paper, Stack, Switch, TextInput } from '@common/ui'
import { com } from '@eidu/web'
import { withKey } from '../../util/withKey'
import FormKeyField from './FormKeyField'
import TrimmedTextInput from './TrimmedTextInput'
import StreamDropDown = com.eidu.sharedlib.form.definition.StreamDropDown

type StreamDropDownItemProps = {
  item: StreamDropDown
  onChange?: (item: StreamDropDown) => void
}

const StreamDropDownItem: React.FC<StreamDropDownItemProps> = ({ item, onChange }) => (
  <Paper withBorder radius="sm" p="xs">
    <Stack gap="md">
      <Group gap="md" wrap="nowrap" align="flex-start">
        <TrimmedTextInput
          style={{ flex: 1 }}
          label="Prompt"
          value={item.prompt}
          onChange={(e) =>
            onChange?.(
              withKey(item.copy(e.target.value, item.key, item.required, item.unfilledText, item.placeholder), item)
            )
          }
          disabled={!onChange}
        />
        <FormKeyField
          value={item.key}
          onChange={(e) =>
            onChange?.(
              withKey(item.copy(item.prompt, e.target.value, item.required, item.unfilledText, item.placeholder), item)
            )
          }
          disabled={!onChange}
        />
      </Group>

      <Group gap="md" wrap="nowrap" align="center">
        <TextInput
          style={{ flex: 1 }}
          label="Unfilled Text"
          value={item.unfilledText ?? ''}
          onChange={(e) =>
            onChange?.(withKey(item.copy(item.prompt, item.key, item.required, e.target.value, item.placeholder), item))
          }
          disabled={!onChange}
        />
        <TextInput
          style={{ flex: 1 }}
          label="Placeholder"
          value={item.placeholder ?? ''}
          onChange={(e) =>
            onChange?.(
              withKey(item.copy(item.prompt, item.key, item.required, item.unfilledText, e.target.value), item)
            )
          }
          disabled={!onChange}
        />
        <Switch
          checked={item.required}
          onChange={(e) =>
            onChange?.(
              withKey(item.copy(item.prompt, item.key, e.target.checked, item.unfilledText, item.placeholder), item)
            )
          }
          disabled={!onChange}
          label="Required"
        />
      </Group>
    </Stack>
  </Paper>
)

export default StreamDropDownItem
